
export const formatErrors = (error) => {

    let errors = [];

    if (error.response) {
  
      switch (error.response.status) {
  
        case 400:
          errors = error.response.data.errors;
          break;
  
        case 500:
          errors.push({ key: "*", message: "Internal server error" });
          break;
  
        default:
          errors.push({ key: "*", message: "Error: " + error.response.status });
          break;
      }
  
    } else {
      errors.push({ key: "*", message: "No response from server" });
    }
  
    return errors;

}

export const getErrors = (id, errors) => {

  let errs = [];
   
  for (let i = 0; i < errors.length; i++) {
    if (errors[i].key.toUpperCase() === id.toUpperCase()) {
      errs.push(errors[i].message);
    }
  }

  return errs;

}

export const getAllErrors = (errors) => {

  let errs = [];
   
  if (errors && errors.length > 0) {
    for (let i = 0; i < errors.length; i++) {
      errs.push(errors[i].message);
    }
  }

  return errs;

}